import { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import styles from './PostsPage.module.css';
import NavBar from '../../components/NavBar';
import PostDisplay from '../../components/PostDisplay';
import ProfileBanner from '../../components/ProfileBanner';
import ProfilePic from '../../components/ProfilePic';
import RealName from '../../components/RealName';
import UserName from '../../components/UserName';
import server from '../../apis/server';
import { UserContext } from '../../contexts/UserContext';

const PostsPage = () => {
  const { username } = useParams();

  const { isLoggedIn } = useContext(UserContext);

  const [realName, setRealName] = useState('');
  const [userImages, setUserImages] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setIsFetching(true);

        const info = await server.get(`/user/${username}`);

        if (isMounted) {
          setRealName(info.data.full_name);

          const images = await server.get(`/user/${username}/images`);

          setIsFetching(false);

          if (isMounted) {
            setUserImages(images.data);
          }
        }
      } catch (err) {
        setIsFetching(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [username]);

  return (
    <div className={styles.postsPage}>
      <NavBar />
      <ProfileBanner
        url={`${process.env.REACT_APP_SERVER_URL}/user/${username}/banner`}
        username={username}
      />
      <div className={styles.userInfo}>
        <ProfilePic
          size="large"
          url={`${process.env.REACT_APP_SERVER_URL}/user/${username}/avatar`}
          upload={isLoggedIn && isLoggedIn.username === username ? true : false}
        />
        <RealName name={realName} />
        <UserName username={`@${username}`} />
      </div>
      <PostDisplay images={userImages} isFetching={isFetching} username={username} />
    </div>
  );
};

export default PostsPage;
